import {
  Button,
  LegacyModal,
  LegacyModalProvider,
  SecondaryButton,
  typography,
} from '@joor/design-system'
import styled from 'styled-components/macro'

import usePortal from 'hooks/usePortal'

export default function WarehouseWarningModal({
  isOpen,
  setOpen,
  action,
  testId = 'warehouse-warning-modal',
}: Props) {
  const Portal = usePortal()
  return (
    <Portal>
      <LegacyModalProvider>
        <StyledModal
          isOpen={isOpen}
          onClose={(): void => setOpen(false)}
          testId={testId}
        >
          <LegacyModal.Title iconName="warning">
            May impact allocations
          </LegacyModal.Title>
          <LegacyModal.Content>
            <StyledContent>
              Changing the warehouse associated this order may impact your
              inventory allocations. Are you sure you want to continue?
            </StyledContent>
          </LegacyModal.Content>
          <StyledActions>
            <SecondaryButton onClick={() => setOpen(false)}>
              Cancel
            </SecondaryButton>
            <Button onClick={action}>Continue</Button>
          </StyledActions>
        </StyledModal>
      </LegacyModalProvider>
    </Portal>
  )
}

type Props = {
  isOpen: boolean
  setOpen: (isOpen: boolean) => void
  action: () => void
  testId?: string
}

const StyledModal = styled(LegacyModal)`
  width: 640px;
`

const StyledContent = styled.p`
  ${typography.alpha.primaryActive.body1}
`

const StyledActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  order: 3;
  gap: 15px;
  padding: 16px 24px 0 16px;
  margin: 0;
  border-top: 1px solid var(--color-primary-200);
`
